import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--backgroundColor, transparent)",
  d: "M3.5 6.389v7.222A2.89 2.89 0 0 0 6.389 16.5h7.222a2.89 2.89 0 0 0 2.889-2.887V6.386A2.887 2.887 0 0 0 13.611 3.5H6.39A2.89 2.89 0 0 0 3.5 6.389"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.4 6v8A1.6 1.6 0 0 0 6 15.6h8c.886 0 1.6-.715 1.6-1.597V5.998c0-.883-.715-1.598-1.6-1.598H6A1.6 1.6 0 0 0 4.4 6M3 14V6a3 3 0 0 1 3-3h8c1.657 0 3 1.34 3 2.998v8.005A2.997 2.997 0 0 1 14 17H6a3 3 0 0 1-3-3",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.85 3.7a.7.7 0 0 1 .7-.7h4.917a.7.7 0 0 1 .7.7v8.308c0 1.031-1.215 1.582-1.99.902l-1.157-1.013-1.184 1.026c-.777.673-1.986.121-1.986-.907zm1.4.7v7.178l.985-.853a1.2 1.2 0 0 1 1.577.004l.956.838V4.4zm-.331 7.465",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=CollectionSingleIcon20.js.map